Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    fontRegular = _STYLES$useStyles.fontRegular,
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    grid = _STYLES$useStyles.grid;
  var _spacer = spacing.normal;
  if (bp.tablet) {
    _spacer = spacing.s;
  }
  var container = {
    width: '100%'
  };
  var emptyMessage = Object.assign({}, fontRegular, {
    fontSize: fontSize.m,
    lineHeight: lineHeight.m,
    textAlign: 'center',
    maxWidth: grid.maxTextWidth,
    alignSelf: 'center'
  });
  var gridStyles = {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    marginHorizontal: 'auto',
    maxWidth: _reactNative.Platform.OS === 'web' ? "calc(".concat(grid.maxTextWidth, " + (").concat(_spacer, " * 2))") : grid.maxTextWidth + _spacer * 2,
    width: '100%'
  };
  var grid_single = {
    alignItems: 'center',
    justifyContent: 'center'
  };
  var gridItem = {
    paddingBottom: spacing.l,
    width: '100%',
    alignItems: 'center'
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    gridItem.width = '50%';
    gridItem.paddingLeft = _spacer;
    gridItem.paddingRight = _spacer;
  }
  if (bp.desktop) {
    gridItem.paddingBottom = spacing.xl;
  }
  var gridItem_single = {
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: grid.maxCardWidth
  };
  var gridItemTemplate = {
    flexGrow: 1
  };
  var toggleContainer = {
    alignSelf: 'center',
    marginTop: spacing.xs
  };
  var styles = _reactNative.StyleSheet.create({
    container: container,
    emptyMessage: emptyMessage,
    grid: gridStyles,
    grid_single: grid_single,
    gridItem: gridItem,
    gridItem_single: gridItem_single,
    gridItemTemplate: gridItemTemplate,
    toggleContainer: toggleContainer
  });
  return {
    styles: styles
  };
};